<template>
  <ui-modal-layout
    :title="tr('Share Report')"
    :description="tr('With the link below, anyone can access the reports of the currently selected advertising account.')"
    :icon="Share2Icon"
  >
    <ui-input
      :model-value="shareUrl"
      readonly
      :aria-label="tr('Share Report')"
      @click="($e) => $e.target.select()"
    />

    <template #footer>
      <ui-button @click="() => copyShareUrl()">
        <copy-icon />
        {{ tr('Copy link') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { Copy, Share2 } from '@lucide/vue';
import { markRaw } from 'vue';

export default {
  name: 'ReportShareModal',
  components: {
    CopyIcon: Copy,
  },
  props: {
    shareUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    Share2Icon: markRaw(Share2),
  }),
  methods: {
    copyShareUrl() {
      navigator.clipboard.writeText(this.shareUrl);
      this.$toast.clear();
      this.$toast.success(this.tr('Link successfully copied to clipboard.'));
      this.$fullscreenModal.closeAll();
    },
  },
};
</script>
